export default __webpack_public_path__ + "static/media/petronas_logo.af2fd977.svg";